import { communityReviewEndpointIds } from 'root/src/server/modules/communityReview/communityReview.fixture';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export const invalidateCommunityReviewsEndpoint = {
    [communityReviewEndpointIds.INVALIDATE_COMMUNITY_REVIEWS]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
